<template>
    <a-result status="404" title="404" sub-title="对不起，当前访问页面不存在">
        <template #extra>
            <a-button type="primary" @click="backHome">回到首页</a-button>
        </template>
    </a-result>
</template>

<script>
export default {
    name: "404",
    methods:{
        backHome(){
            this.$router.replace('/');
        }
    }
}
</script>

<style scoped>

</style>
